(function ($) {
    "use strict";

    var $doc = $(document),
        $win = $(window);


    $.fn.tooltip.Constructor.DEFAULTS.trigger   = 'hover focus';
    // $.fn.tooltip.Constructor.DEFAULTS.container = document.body;

    // Dropdown active class on link
    // -----------------------------
    $doc.on('show.bs.dropdown', '.dropdown-menu', function (event) {
        var $this   = $(this),
            $toggle = $(event.relatedTarget);

        $this.data('popel.toggle', $toggle);

        $toggle.addClass('active');
    });

    $doc.on('hide.bs.dropdown', '.dropdown-menu', function () {
        var $this   = $(this),
            $toggle = $this.data('popel.toggle');

        $toggle.removeClass('active');
    });


    // Print button
    // ------------
    $doc.on('click', '[data-toggle="print"]', function (event) {
        event.preventDefault();

        window.print();
    });


    // Video placeholder
    // -----------------
    $doc.on('click', '[data-toggle="video-placeholder"]', function (event) {
        event.preventDefault();

        var $this   = $(this),
            $parent = $this.closest('.video-placeholder');

        $parent.addClass('active');
    });


    // Preloader
    // ---------
    var domReady  = $.Deferred(),
        winLoaded = $.Deferred();

    $(function () {
        domReady.resolve();
    });

    $win.on('load', function () {
        winLoaded.resolve();
    });

    $.when(domReady, winLoaded).then(function () {
        var $preloader = $('#page-preloader');

        if ($.support.transition) {
            $preloader.one('bsTransitionEnd', function () {
                $preloader.remove();
            }).emulateTransitionEnd(1000);
        } else {
            $preloader.hide()
            $preloader.remove();
        }

        $(document.body).addClass('loaded').removeClass('loading');
        $doc.trigger('load.popel.preloader');
    });


    // Facebook pixel
    // --------------
    $doc.on('click', '[data-fbq-action]', function () {
        var $this = $(this),
            action = $this.data('fbq-action');
        window.fbq && fbq('track', action);
    });

})(window.jQuery);
